import React from 'react';
import { Bath, ChefHat, CircleParking, Flame, House, Snowflake, Trees, Waves } from 'lucide-react';
import { FadeIn } from './FadeIn';
const FACILITIES = [{
  label: 'Boutique accommodation',
  icon: House
}, {
  label: 'Wood-fired sauna',
  icon: Flame
}, {
  label: 'Cedar hot tub',
  icon: Bath
}, {
  label: 'Cold plunges',
  icon: Snowflake
}, {
  label: 'Swimming pool',
  icon: Waves
}, {
  label: 'Geodesic dome',
  icon: Trees
}, {
  label: 'Outdoor kitchen',
  icon: ChefHat
}, {
  label: 'Fire pit & parking',
  icon: CircleParking
}];
export function Facilities() {
  return <section className="bg-creamDeep px-6 py-20 md:px-12 md:py-28" data-id="element-60" data-mp="fesqgp1pvhui">
      <div className="mx-auto max-w-6xl" data-id="element-61" data-mp="fhnawgkqd2nx">
        <div className="mb-12 max-w-2xl" data-id="element-62" data-mp="kene8jq73rbc">
          <FadeIn data-id="element-63" data-mp="kcaovli3yeo9">
            <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-64" data-mp="1quhdfgez0gvb">
              Facilities
            </p>
          </FadeIn>
          <FadeIn delay={0.1} data-id="element-65" data-mp="1vs9281kbjmva">
            <h2 className="font-serif text-4xl leading-tight text-pine md:text-5xl" data-id="element-66" data-mp="1vvn65e8ms44u">
              Everything you need to gather, rest, and reset.
            </h2>
          </FadeIn>
        </div>

        <div className="grid grid-cols-2 border-l border-t border-pine/15 sm:grid-cols-4" data-id="element-67" data-mp="3hi673i585nee">
          {FACILITIES.map((facility, index) => {
          const Icon = facility.icon;
          return <FadeIn key={facility.label} delay={index * 0.05} data-id="element-68" data-mp="37ofnaqk1m151" data-mpi={index}>
                <div className="flex min-h-36 flex-col justify-between border-b border-r border-pine/15 bg-cream p-5 md:min-h-40 md:p-6" data-id="element-69" data-mp="33l9jrqobeo29">
                  <Icon className="h-5 w-5 text-ember" data-id="element-70" data-mp="2yrwv5gjmyh9i" />
                  <span className="max-w-[10rem] text-sm font-medium leading-snug text-pine" data-id="element-71" data-mp="2tvgawxfk4n1p">
                    {facility.label}
                  </span>
                </div>
              </FadeIn>;
        })}
        </div>
      </div>
    </section>;
}